module.exports = __webpack_public_path__ + "static/media/IconMap.c2315f9b.svg";